module.exports = __webpack_public_path__ + "img/thumb_aula45.48fb4165.jpg";